module.exports = __webpack_public_path__ + "img/1.a94d3a4d.png";